// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import ga from 'vue-ga'
import store from './store'
// import swipe from '@/components/swipe/swipe.vue'
import spinner from '@/components/common/spinner'
import { mapState } from 'vuex'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import './styles/swiper.min.css'

import Crop from './components/common/crop'
import './utils/zm.js'

import Utils from './common/utils'
import VueClipboard from 'vue-clipboard2'
import JsBridge from './utils/jsbridge'
const packageJson = require('./../package.json')
const APPID = '10560'

Vue.config.productionTip = false
// Vue.component(swipe.name, swipe)
Vue.component(spinner.name, spinner)
Vue.use(VueAwesomeSwiper)
Vue.use(Crop)
Vue.use(VueClipboard)
Vue.use(JsBridge, {
  callback: bridge => {
    window.zm1v1jsBridge = bridge
  }
})
// ga统计
ga(router, 'UA-85726094-1')

let environment = 'prod'
if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'testing') {
  // ZMSDK.topic = 'h5sdk_test'
  environment = 'fat'
}
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '掌门1对1官方网站-高端中小学在线教育辅导品牌-名校精英在线学习-掌门一对一'
  if (to.name === 'ab_jump_home' ||to.name === 'ab_jump') {
    const path = to.path.replace('/AB', '')
    const query = to.query
    // eslint-disable-next-line
    var url = path + '?' + JSON.stringify(query).replace(/[\"\{\}]/g, '').replace(/\:/g, '=').replace(/\,/g, '&')
    // 判断不同的环境
    if (Utils.isDev()) {
      window.location.href = 'https://v2-test.zmaxis.com/abtest/m' + url
    } else if (Utils.isUat()) {
      window.location.href = 'https://www.uat.zmops.cc/abtest/m' + url
    } else if (Utils.isProduction()) {
      window.location.href = 'https://www.zhangmen.com/abtest/m' + url
    }
  }
  next()
})

console.log('environment', environment, 'process.env.NODE_ENV=', process.env.NODE_ENV)

/* eslint-disable no-new */
new Vue({
  router,
  store,
  computed: mapState(['isLoading'])
}).$mount('#app')

const { ZM_JSSDK } = window
if (ZM_JSSDK) {
  ZM_JSSDK.setConfig({
    environment: environment,
    history: true,
    interceptor: false,
    urlParams: true
  })
  ZM_JSSDK.setDefaults({
    appId: `${APPID}`,
    appVersion: packageJson.version,
    deviceId: localStorage.getItem('ZM_DEVICEID')
  })
}
